export default {"src":"/_next/static/media/instagram.b79cfe83.svg","height":1000,"width":1000};